window.dist3D = function (p1, p2) {
  // d = √ [(x2-x1)2 + (y2-y1)2 + (z2-z1)2]
  return Math.sqrt(Math.pow(p2.x - p1.x, 2) + Math.pow(p2.y - p1.y, 2) + Math.pow(p2.z - p1.z, 2));
}

window.constrain = function (aNumber, aMin, aMax) {
	return aNumber > aMax ? aMax : aNumber < aMin ? aMin : aNumber;
};

window.map = function (n, start1, stop1, start2, stop2, withinBounds) {
  var newval = (n - start1) / (stop1 - start1) * (stop2 - start2) + start2;
  if (!withinBounds) {
    return newval;
  }
  if (start2 < stop2) {
    return this.constrain(newval, start2, stop2);
  } else {
    return this.constrain(newval, stop2, start2);
  }
};

window.randomInRange = function (map, prop) {
	var min = map[prop + "Min"],
		max = map[prop + "Max"];
	return min + (max - min) * Math.random();
}

window.getRandomInt = function (min, max, useSeed) {
  if (typeof useSeed !== "undefined" && useSeed == true) {
    return Math.floor(randomSeed.random() * (max - min + 1)) + min;
  } else {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }
}

window.getRandomFloat = function (min, max, useSeed) {
  if (typeof useSeed !== "undefined" && useSeed == true) {
    return randomSeed.random() * (max - min + 1) + min;
  } else {
    return Math.random() * (max - min + 1) + min;
  }
}

window.getURLParameter = function (name) {
	return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.search) || [, ""])[1].replace(/\+/g, '%20')) || null;
};

window.millis = function () {
	return Date.now();
}

window.shuffle = function (array) {
	var currentIndex = array.length, temporaryValue, randomIndex;

	// While there remain elements to shuffle...
	while (0 !== currentIndex) {

		// Pick a remaining element...
		randomIndex = Math.floor(Math.random() * currentIndex);
		currentIndex -= 1;

		// And swap it with the current element.
		temporaryValue = array[currentIndex];
		array[currentIndex] = array[randomIndex];
		array[randomIndex] = temporaryValue;
	}

	return array;
}

window.getDate = function (language) {

	var objToday = new Date();
	var weekday, dayOfWeek, domEnder, dayOfMonth, months, curMonth, curYear, curHour, curMinute, curSeconds,
		curMeridiem, dayOfMonthNoEnd;

	if (language == "fr") {
		objToday = new Date();
		weekday = new Array('Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi');
		months = new Array('Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juilet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre');
	} else {
		objToday = new Date();
		weekday = new Array('Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday');
		months = new Array('January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December');
	}

	domEnder = new Array('th', 'st', 'nd', 'rd', 'th', 'th', 'th', 'th', 'th', 'th');
	dayOfWeek = weekday[objToday.getDay()];
	dayOfMonthNoEnd = objToday.getDate();
	dayOfMonth = (objToday.getDate() < 10) ? '0' + objToday.getDate() + domEnder[objToday.getDate()] : objToday.getDate() + domEnder[parseFloat(("" + objToday.getDate()).substr(("" + objToday.getDate()).length - 1))];
	curMonth = months[objToday.getMonth()];
	curYear = objToday.getFullYear();
	curHour = objToday.getHours() > 12 ? objToday.getHours() - 12 : (objToday.getHours() < 10 ? "0" + objToday.getHours() : objToday.getHours());
	curMinute = objToday.getMinutes() < 10 ? "0" + objToday.getMinutes() : objToday.getMinutes();
	curSeconds = objToday.getSeconds() < 10 ? "0" + objToday.getSeconds() : objToday.getSeconds();
	curMeridiem = objToday.getHours() > 12 ? "PM" : "AM";

	if (language == "fr") {
		//return (dayOfWeek + " " + dayOfMonthNoEnd + " " + curMonth + " " + curYear);
		return (dayOfWeek + " " + dayOfMonthNoEnd + " " + curMonth);
	} else if (language == "hour") {
		return (curHour + ":" + curMinute + " " + curMeridiem);
	} else {
		//return (dayOfWeek + " " + curMonth + " " + dayOfMonth + " " + curYear);
		return (dayOfWeek + " " + curMonth + " " + dayOfMonth);
	}
};

window.guid = function () {
  function s4() {
    return Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1);
  }

  return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
}

var convertSVGToInline = function (callback) {

	var count = 0;
	var total = $('img.svg').length;

	$('img.svg').each(function () {
		var $img = $(this);
		var imgID = $img.attr('id');
		var imgClass = $img.attr('class');
		var imgURL = $img.attr('src');

		$.ajax({
			url: imgURL,
			error: $.proxy(function ($img, imgID, imgClass, data) {
				count++;
			}, this, $img, imgID, imgClass),
			success: $.proxy(function ($img, imgID, imgClass, data) {
				// Get the SVG tag, ignore the rest
				var $svg = $("<div>" + data + "</div>").find('svg');
				// Add replaced image's ID to the new SVG
				if (typeof imgID !== 'undefined') {
					$svg = $svg.attr('id', imgID);
				}
				// Add replaced image's classes to the new SVG
				if (typeof imgClass !== 'undefined') {
					$svg = $svg.attr('class', imgClass + ' replaced-svg');
				}
				// Remove any invalid XML tags as per http:validator.w3.org
				$svg = $svg.removeAttr('xmlns:a');
				// Replace image with new SVG
				$img.replaceWith($svg);

				count++;
				if (count >= total && typeof  callback != "undefined") {
					callback();
				}

			}, this, $img, imgID, imgClass),
			dataType: "text"
		});
	});
}

/*!
 * Behaves the same as setInterval except uses requestAnimationFrame() where possible for better performance
 * modified gist.github.com/joelambert/1002116
 * the fallback function requestAnimFrame is incorporated
 * gist.github.com/joelambert/1002116
 * gist.github.com/englishextra/873c8f78bfda7cafc905f48a963df07b
 * jsfiddle.net/englishextra/sxrzktkz/
 * @param {Object} fn The callback function
 * @param {Int} delay The delay in milliseconds
 * requestInterval(fn, delay);
 */
var requestInterval = function (fn, delay) {
	var requestAnimFrame = (function () {
			return window.requestAnimationFrame || function (callback, element) {
				window.setTimeout(callback, 1000 / 60);
			};
		})(),
		start = new Date().getTime(),
		handle = {};

	function loop() {
		handle.value = requestAnimFrame(loop);
		var current = new Date().getTime(),
			delta = current - start;
		if (delta >= delay) {
			fn.call();
			start = new Date().getTime();
		}
	}

	handle.value = requestAnimFrame(loop);
	return handle;
};
/*!
 * Behaves the same as clearInterval except uses cancelRequestAnimationFrame()
 * where possible for better performance
 * gist.github.com/joelambert/1002116
 * gist.github.com/englishextra/873c8f78bfda7cafc905f48a963df07b
 * jsfiddle.net/englishextra/sxrzktkz/
 * @param {Int|Object} handle function handle, or function
 * clearRequestInterval(handle);
 */
var clearRequestInterval = function (handle) {
	if (window.cancelAnimationFrame) {
		window.cancelAnimationFrame(handle.value);
	} else {
		window.clearInterval(handle);
	}
};
/*!
 * Behaves the same as setTimeout except uses requestAnimationFrame()
 * where possible for better performance
 * modified gist.github.com/joelambert/1002116
 * the fallback function requestAnimFrame is incorporated
 * gist.github.com/joelambert/1002116
 * gist.github.com/englishextra/873c8f78bfda7cafc905f48a963df07b
 * jsfiddle.net/englishextra/dnyomc4j/
 * @param {Object} fn The callback function
 * @param {Int} delay The delay in milliseconds
 * requestTimeout(fn,delay);
 */
var requestTimeout = function (fn, delay) {
	var requestAnimFrame = (function () {
			return window.requestAnimationFrame || function (callback, element) {
				window.setTimeout(callback, 1000 / 60);
			};
		})(),
		start = new Date().getTime(),
		handle = {};

	function loop() {
		var current = new Date().getTime(),
			delta = current - start;
		if (delta >= delay) {
			fn.call();
		} else {
			handle.value = requestAnimFrame(loop);
		}
	}

	handle.value = requestAnimFrame(loop);
	return handle;
};
/*!
 * Behaves the same as clearTimeout except uses cancelRequestAnimationFrame()
 * where possible for better performance
 * gist.github.com/joelambert/1002116
 * gist.github.com/englishextra/873c8f78bfda7cafc905f48a963df07b
 * jsfiddle.net/englishextra/dnyomc4j/
 * @param {Int|Object} handle The callback function
 * clearRequestTimeout(handle);
 */
var clearRequestTimeout = function (handle) {
	if (window.cancelAnimationFrame) {
		window.cancelAnimationFrame(handle.value);
	} else {
		window.clearTimeout(handle);
	}

};

// https://stackoverflow.com/questions/7424155/javascript-how-to-get-setinterval-to-start-now
var setIntervalAndExecute = function (fn, t) {
	fn();
	return (setInterval(fn, t));
}

// Enables prototype inheritence using this simple command
// https://stackoverflow.com/questions/4152931/javascript-inheritance-call-super-constructor-or-use-prototype-chain
function extend(base, sub) {
	// Avoid instantiating the base class just to setup inheritance
	// Also, do a recursive merge of two prototypes, so we don't overwrite
	// the existing prototype, but still maintain the inheritance chain
	// Thanks to @ccnokes
	var origProto = sub.prototype;
	sub.prototype = Object.create(base.prototype);
	for (var key in origProto) {
		sub.prototype[key] = origProto[key];
	}
	// The constructor property was set wrong, let's fix it
	Object.defineProperty(sub.prototype, 'constructor', {
		enumerable: false,
		value: sub
	});
}

function getPosition(el) {
	// console.log(el);
	var rect = el.getBoundingClientRect();
	var curTransform = new WebKitCSSMatrix(window.getComputedStyle(el).webkitTransform);
	return {
		x: rect.left,
		y: rect.top,
		left: rect.left,
		top: rect.top,
		right: rect.right,
		bottom: rect.bottom,
		translateX: curTransform.m41,
		translateY: curTransform.m42,
		combinedX: rect.left + curTransform.m41,
		combinedY: rect.top + curTransform.m42,
	};
}

// Based on https://stackoverflow.com/a/8435261
// Usage : weightedRandom({0:0.8, 1:0.15, 2:0.05})
// Sum of all the specs must be equal to 1
function weightedRandom(spec) {
	var i, j, table = [];

	var constant = 1;
	for (i in spec) {
		constant = Math.max(constant, spec[i].toString().split('.')[1].length);
	}

	for (i in spec) {
		for (j = 0; j < spec[i] * Math.pow(10, constant); j++) {
			table.push(i);
		}
	}

	return table[Math.floor(Math.random() * table.length)];
}

// https://stackoverflow.com/a/22209579/1617768
// Adapted by Marc-Antoine Brodeur to search by property instead of data
// You can search for a key-value pair, you can additionally search for the presence of a prop, irrespective of its value.
//
// Usage:
//
// $('<b>').data('x', 1).filterByProperty('x', 1).length    // output: 1
// $('<b>').data('x', 1).filterByProperty('x').length       // output: 1

;(function ($) {

	$.fn.filterByProperty = function (prop, val) {
		var $self = this;
		if (typeof val === 'undefined') {
			return $self.filter(
				function () {
					return typeof $(this).prop(prop) !== 'undefined';
				}
			);
		}
		return $self.filter(
			function () {
				return $(this).prop(prop) == val;
			}
		);
	};

})(jQuery);

/**
 * jQuery alterClass plugin
 *
 * Remove element classes with wildcard matching. Optionally add classes:
 *   $( '#foo' ).alterClass( 'foo-* bar-*', 'foobar' )
 *
 * Copyright (c) 2011 Pete Boere (the-echoplex.net)
 * Free under terms of the MIT license: http://www.opensource.org/licenses/mit-license.php
 *
 */
(function ($) {

	$.fn.alterClass = function (removals, additions) {

		var self = this;

		if (removals.indexOf('*') === -1) {
			// Use native jQuery methods if there is no wildcard matching
			self.removeClass(removals);
			return !additions ? self : self.addClass(additions);
		}

		var patt = new RegExp('\\s' +
			removals.replace(/\*/g, '[A-Za-z0-9-_]+').split(' ').join('\\s|\\s') +
			'\\s', 'g');

		self.each(function (i, it) {
			var cn = ' ' + it.className + ' ';
			while (patt.test(cn)) {
				cn = cn.replace(patt, ' ');
			}
			it.className = $.trim(cn);
		});

		return !additions ? self : self.addClass(additions);
	};

})(jQuery);

window.transEndEventNames = {
	'WebkitTransition': 'webkitTransitionEnd',
	'MozTransition': 'transitionend',
	'OTransition': 'oTransitionEnd otransitionend',
	'msTransition': 'MSTransitionEnd',
	'transition': 'transitionend'
};
window.transitionEnd = window.transEndEventNames[Modernizr.prefixed('transition')];

window.animEndEventNames = {
	'WebkitAnimation': 'webkitAnimationEnd',
	'MozAnimation': 'Animationend',
	'OAnimation': 'oAnimationEnd oAnimationend',
	'msAnimation': 'MSAnimationEnd',
	'animation': 'animationend'
};
window.animationEnd = window.animEndEventNames[Modernizr.prefixed('animation')];
